import React from "react";

import { Chip } from "@material-ui/core";

import { useRoleChipStyles } from "./RoleChip.styles";

import { userRoles } from "modules/user/utils/constants";

import { UserRole } from "modules/user/types/entities";

interface IRoleChipProps {
  role: UserRole;
}

const RoleChip: React.FC<IRoleChipProps> = ({ role }) => {
  const classes = useRoleChipStyles({ role });

  return (
    <Chip
      component="span"
      variant="outlined"
      label={userRoles[role]}
      className={classes.chip}
    />
  );
};

export default RoleChip;
